import Vue from 'vue'
import router from '@/router'

/**
 * 获取uuid
 */
export function getUUID () {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
    return (c === 'x' ? (Math.random() * 16 | 0) : ('r&0x3' | '0x8')).toString(16)
  })
}

/**
 * 是否有权限
 * @param {*} key
 */
export function isAuth (key) {
  return JSON.parse(sessionStorage.getItem('permissions') || '[]').indexOf(key) !== -1 || false
}

/**
 * 树形数据转换
 * @param {*} data
 * @param {*} id
 * @param {*} pid
 */
export function treeDataTranslate (data, id = 'id', pid = 'parentId') {
  var res = []
  var temp = {}
  for (var i = 0; i < data.length; i++) {
    temp[data[i][id]] = data[i]
  }
  for (var k = 0; k < data.length; k++) {
    if (temp[data[k][pid]] && data[k][id] !== data[k][pid]) {
      if (!temp[data[k][pid]]['children']) {
        temp[data[k][pid]]['children'] = []
      }
      if (!temp[data[k][pid]]['_level']) {
        temp[data[k][pid]]['_level'] = 1
      }
      data[k]['_level'] = temp[data[k][pid]]._level + 1
      temp[data[k][pid]]['children'].push(data[k])
    } else {
      res.push(data[k])
    }
  }
  return res
}

/**
 * 清除登录信息
 */
export function clearLoginInfo () {
  Vue.cookie.delete('token')
  Vue.cookie.delete('userType')
  Vue.cookie.delete('userId')
  Vue.cookie.delete('account')
  Vue.cookie.delete('headImg')
  Vue.cookie.delete('name')
  Vue.cookie.delete('loginCount')
  Vue.cookie.delete('pcOpenid')
  Vue.cookie.delete('isInstructional')
  Vue.cookie.delete('isSurSupervisor')
  Vue.cookie.delete('microCourses')
  Vue.cookie.delete('microVideo')
  Vue.cookie.delete('qualityCourses')
  Vue.cookie.delete('isAppealAuditor')
  Vue.cookie.delete('isEvaluationTeacher')
  Vue.cookie.delete('isEvaClass')
  router.options.isAddDynamicMenuRoutes = false
}

export function setLoginInfo (loginToken) {
  Vue.cookie.set('token', loginToken.token)
  Vue.cookie.set('userType', loginToken.userType)
  Vue.cookie.set('userId', loginToken.userId)
  Vue.cookie.set('account', loginToken.account)
  Vue.cookie.set('headImg', loginToken.headImg)
  Vue.cookie.set('name', loginToken.name)
  Vue.cookie.set('pcOpenid', loginToken.pcOpenid)
  Vue.cookie.set('loginCount', loginToken.loginCount)
  Vue.cookie.set('isInstructional', loginToken.isInstructional)
  Vue.cookie.set('classId', loginToken.classId)
}

export function setUserInfo (user) {
  Vue.cookie.set('headImg', user.img)
  Vue.cookie.set('name', user.name)
}

export const niceScroll = {
  selector (selector) {
    return jQuery(selector).niceScroll()
  },
  resize (selector) {
    jQuery(selector).getNiceScroll().resize()
  }
}



// WEBPACK FOOTER //
// ./src/utils/index.js